import React from 'react';

import { VirtualizedListV2 } from '@gogame/components';

import { useSearch } from '../UserPermissions';

const defaultGetOptionLabel = ({ name }) => name;
const defaultGetOptionValue = ({ id }) => id;

const PermissionList = ({
  options,
  getOptionLabel = defaultGetOptionLabel,
  getOptionValue = defaultGetOptionValue,
}) => {
  const { searchQuery, filteredOptions } = useSearch({ options });

  return (
    <VirtualizedListV2
      data={filteredOptions}
      withSearch={!!searchQuery}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
};

export default PermissionList;
